import dayjs from 'dayjs';

// Jours fériés français. Fichier partagé à l'identique entre we-kiosk-order, we-kiosk-order-app et we-eats-order.
// Utilisé partout (horaires cuisine ET disponibilité produits) avec fêtes fixes + mobiles.
// FIXED holidays recur every year (DD/MM); MOVEABLE holidays are dated (DD/MM/YYYY).

export const FIXED_PUBLIC_HOLIDAYS = ['01/01', '01/05', '08/05', '14/07', '15/08', '01/11', '11/11', '25/12'];

export const MOVEABLE_PUBLIC_HOLIDAYS = [
  '21/04/2025', '29/05/2025', '09/06/2025',
  '06/04/2026', '14/05/2026', '25/05/2026',
  '29/03/2027', '06/05/2027', '17/05/2027',
  '17/04/2028', '25/05/2028', '05/06/2028',
  '02/04/2029', '10/05/2029', '21/05/2029',
  '22/04/2030', '30/05/2030', '10/06/2030',
  '14/04/2031', '22/05/2031', '02/06/2031',
  '29/03/2032', '06/05/2032', '17/05/2032',
  '18/04/2033', '26/05/2033', '06/06/2033',
  '10/04/2034', '18/05/2034', '29/05/2034',
  '26/03/2035', '03/05/2035', '14/05/2035',
  '14/04/2036', '22/05/2036', '02/06/2036',
  '06/04/2037', '14/05/2037', '25/05/2037',
  '26/04/2038', '03/06/2038', '14/06/2038',
  '11/04/2039', '19/05/2039', '30/05/2039',
  '02/04/2040', '10/05/2040', '21/05/2040',
  '22/04/2041', '30/05/2041', '10/06/2041',
  '07/04/2042', '15/05/2042', '26/05/2042',
  '30/03/2043', '07/05/2043', '18/05/2043',
  '18/04/2044', '26/05/2044', '06/06/2044',
  '10/04/2045', '18/05/2045', '29/05/2045',
  '26/03/2046', '03/05/2046', '14/05/2046',
  '15/04/2047', '23/05/2047', '03/06/2047',
  '06/04/2048', '14/05/2048', '25/05/2048',
  '19/04/2049', '27/05/2049', '07/06/2049',
  '11/04/2050', '19/05/2050', '30/05/2050',
];

/** Jour férié aujourd'hui ? Fêtes fixes (récurrentes) et mobiles (Pâques, Ascension, Pentecôte). */
export function isPublicHolidayToday(now = dayjs()) {
  return FIXED_PUBLIC_HOLIDAYS.includes(now.format('DD/MM'))
    || MOVEABLE_PUBLIC_HOLIDAYS.includes(now.format('DD/MM/YYYY'));
}
